import dayjs from "dayjs";

import { type ITimeLeft, type IDiscountTimeParams, ZERO_TIME_LEFT } from "./consts";
import type { IDiscountConfig } from "./discountConfig";

const pluralize = (value: number, singular: string, plural: string) => `${value} ${value === 1 ? singular : plural}`;

export const getDiscountEndTime = (config: IDiscountConfig): string => {
    return `${config.endDate}T00:00:00`;
};

export const getIsExpired = (timeLeft: ITimeLeft) => timeLeft === ZERO_TIME_LEFT;

export const calculateTimeLeft = ({ discountEndTime }: IDiscountTimeParams): ITimeLeft => {
    const endTimeString = discountEndTime;
    if (!endTimeString) {
        return ZERO_TIME_LEFT;
    }

    const now = dayjs();
    const endTime = dayjs(endTimeString);
    if (!endTime.isValid() || now.isAfter(endTime)) {
        return ZERO_TIME_LEFT;
    }

    const difference = endTime.diff(now);
    const diffDuration = dayjs.duration(difference);

    const days = Math.floor(diffDuration.asDays());
    const hours = diffDuration.hours();
    const minutes = diffDuration.minutes();
    const seconds = diffDuration.seconds();

    if (diffDuration.asSeconds() <= 0) {
        return ZERO_TIME_LEFT;
    }

    return {
        days,
        hours,
        minutes,
        seconds,
    };
};

export const getIsInDiscount = (params: IDiscountTimeParams): boolean => {
    const timeLeft = calculateTimeLeft(params);
    return !getIsExpired(timeLeft);
};

export const getFormattedTimeLeft = (params: IDiscountTimeParams): string => {
    const { days, hours, minutes, seconds } = calculateTimeLeft(params);

    return [
        pluralize(+days, "day", "days"),
        pluralize(+hours, "hour", "hours"),
        pluralize(+minutes, "minute", "minutes"),
        pluralize(+seconds, "second", "seconds"),
    ].join(", ");
};
